(function() {
  const itemsToShow = 12;
  const galleryGrid = document.querySelector('.gallery__grid');
  const moreButton = document.querySelector('.more__btn');
  
  if (!galleryGrid || !moreButton) return;
  
  const galleryItems = Array.from(galleryGrid.children);
  const totalItems = galleryItems.length;
  let visibleCount = 0;
  
  // Добавляем CSS класс для анимации
  const style = document.createElement('style');
  style.textContent = `
    .gallery__item {
      transition: opacity 0.3s ease, transform 0.3s ease;
    }
    .gallery__item.hidden {
      opacity: 0;
      transform: scale(0.8);
      pointer-events: none;
    }
  `;
  document.head.appendChild(style);
  
  function updateVisibility() {
    galleryItems.forEach((item, index) => {
      if (index < visibleCount) {
        item.classList.remove('hidden');
        item.style.display = '';
      } else {
        item.classList.add('hidden');
        // Небольшая задержка перед скрытием для плавности
        setTimeout(() => {
          if (item.classList.contains('hidden')) {
            item.style.display = 'none';
          }
        }, 300);
      }
    });
    
    if (visibleCount >= totalItems) {
      moreButton.style.display = 'none';
    }
  }
  
  function showMore() {
    const newCount = Math.min(visibleCount + itemsToShow, totalItems);
    
    // Сначала показываем элементы
    for (let i = visibleCount; i < newCount; i++) {
      galleryItems[i].style.display = '';
      setTimeout(() => {
        galleryItems[i].classList.remove('hidden');
      }, 10);
    }
    
    visibleCount = newCount;
    
    if (visibleCount >= totalItems) {
      setTimeout(() => {
        moreButton.closest('.gallery__more').remove();
      }, 300);
    }
  }
  
  moreButton.addEventListener('click', showMore);
  
  // Инициализация
  const dataCount = parseInt(galleryGrid.getAttribute('data-count'), 10);
  const initialCount = isNaN(dataCount) ? itemsToShow : dataCount;
  visibleCount = Math.min(initialCount, totalItems);
  
  // Добавляем классы всем элементам
  galleryItems.forEach((item, index) => {
    item.classList.add('gallery__item');
    if (index >= visibleCount) {
      item.classList.add('hidden');
      item.style.display = 'none';
    }
  });
})();